import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { cloudFunctionsInstance } from 'config/axios'
import { toast } from 'utils/notify'

const useValidateOrganizationToken = () => {
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [refetch, setRefetch] = useState(true)
  // get token and type fro query params
  const token = new URLSearchParams(location.search).get('token')
  const organizationType = new URLSearchParams(location.search).get('type')

  const [apiResponse, setApiResponse] = useState(null)

  const getOrganizationByToken = async () => {
    try {
      setLoading(true)
      const response = await cloudFunctionsInstance.get(`/getOrganizationByToken?token=${token}`)
      setApiResponse(response.data)
    } catch (err) {
      toast.error(
        err?.response?.data?.msg || 'Something went wrong when fetching the data. Please try again.'
      )
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getOrganizationByToken()
  }, [])

  useEffect(() => {
    if (refetch && token) {
      getOrganizationByToken()
    }
  }, [token, organizationType, refetch])

  return {
    isLoading: loading,
    isTokenValid: !!apiResponse?.conference?.id,
    organization: apiResponse?.organization ?? null,
    conference: apiResponse?.conference ?? null,
    refetch: () => setRefetch(true)
  }
}

export default useValidateOrganizationToken
